import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import App from './App'

declare global {
  interface Window {
    monkeeTranscription?: {
      ajaxUrl: string
      apiBaseUrl: string
      aiBaseUrl?: string
      restUrl: string
      nonce: string
      apiKey: string
      encryptedKey: string
      userId: number
      userEmail: string
      tennantId?: string
    }
    MonkeeReactApp?: {
      mount: (selector?: string) => void
    }
  }
}

function mount(selector = '#monkee-file-transcript-client') {
  // Tentar encontrar o container pelo seletor fornecido
  let container = document.querySelector(selector) as HTMLElement | null
  
  // Fallback: tentar outros IDs comuns
  if (!container) {
    container = document.getElementById('monkee-transcription-root') as HTMLElement | null
  }
  
  // Se ainda não encontrou, criar um novo container
  if (!container) {
    container = document.createElement('div')
    container.id = 'monkee-file-transcript-client'
    document.body.appendChild(container)
  }
  const root = ReactDOM.createRoot(container)
  const theme = createTheme({
    palette: {
      mode: 'light',
      primary: { main: '#1976d2' }
    },
    shape: { borderRadius: 10 }
  })

  root.render(
    <ThemeProvider theme={theme}>
      <App config={window.monkeeTranscription} />
    </ThemeProvider>
  )
}

// Auto-mount if running standalone (Vite dev or CDN page with container present)
const autoMountContainer = document.getElementById('monkee-file-transcript-client') || 
                           document.getElementById('monkee-transcription-root')
if (autoMountContainer) {
  mount('#' + autoMountContainer.id)
}

// Expose for WordPress to call after enqueue
window.MonkeeReactApp = { mount }
